module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-xpc-button-more"
  }, [_c('rt-button', {
    attrs: {
      "suffix-icon": _vm.suffixIcon,
      "color-type": _vm.buttonColor,
      "text": "",
      "type": "plain"
    },
    on: {
      "click": _vm._changeExpand
    }
  }, [_vm._v("\n    " + _vm._s(_vm.buttonText) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-006c2f48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/button/rtButtonMore.vue
// module id = 2058
// module chunks = 137